export function imprimirEtiquetasVisita(configuracionLanding) {
  const etiquetasVisita = configuracionLanding.etiquetas.visita

  for (const [etqId, etqValor] of Object.entries(etiquetasVisita)) {
    window[etqId] = etqValor
    console.log('Etiqueta visita', etqId, window[etqId])
  }
}
